export const SESSION_COLUMN_STYLE = { width: '209px', maxWidth: '209px' } as const;
